import { ChevronDown, SlidersHorizontal } from 'lucide-react'
import { useId, useState } from 'react'

import { Button, TreeNav } from '@krp/ui-kit'

import type { CashReceiptsNavVm } from '../model/types'

/** Магазин выбирается сразу; организации и конкретные кассы доступны в подробном выборе. */
export function CashReceiptsPlacePicker({ nav, onSelect, onToggle }: {
  nav: CashReceiptsNavVm
  onSelect: (id: string) => void
  onToggle: (id: string) => void
}) {
  const name = useId()
  const panelId = useId()
  const [detailed, setDetailed] = useState(false)
  const advanced = !nav.stores.some((store) => store.id === nav.selectedId)
  return <div className="onec-receipts-place">
    <div className="onec-receipts-place__stores" role="radiogroup" aria-label="Магазин">
      {nav.stores.map((store) => <label key={store.id} className="onec-receipts-place__store" data-selected={store.id === nav.selectedId || undefined}>
        <input type="radio" name={name} value={store.id} checked={store.id === nav.selectedId} onChange={() => onSelect(store.id)} />
        <span className="onec-receipts-place__text"><strong>{store.label}</strong>{store.caption !== null && <small>{store.caption}</small>}</span>
        {store.badge !== null && <span className="krp-tree__badge">{store.badge}</span>}
      </label>)}
    </div>
    {advanced && <p className="onec-receipts-place__selection">Подробный отбор: {nav.summaryText}</p>}
    <div className="onec-receipts-place__details">
      <Button variant="ghost" aria-expanded={detailed} aria-controls={panelId} onClick={() => setDetailed((current) => !current)}
        icon={detailed ? <ChevronDown size={16} aria-hidden="true" /> : <SlidersHorizontal size={16} aria-hidden="true" />}>
        Подробный выбор
      </Button>
      <div id={panelId} hidden={!detailed}>
        {detailed && <TreeNav label="Где смотрим: организации, магазины и кассы" nodes={nav.nodes} onSelect={onSelect} onToggle={onToggle} />}
      </div>
    </div>
  </div>
}
